import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Contact from '@/pages/ContactUs'
import Products from '@/pages/Products'
import ProductDetails from '@/pages/ProductDetails'
import News from '@/pages/News'
import Search from '@/pages/Search'
import NewsDetails from '@/pages/NewsDetails'
import JoinUs from '@/pages/JoinUs'
import Elements from '@/pages/Elements'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/products',
      name: 'products',
      component: Products
    },
    {
      path: '/productDetails',
      name: 'productDetails',
      component: ProductDetails
    },
    {
      path: '/news',

      name: 'news',
      component: News
    },
    {
      path: '/newsDetails',
      name: 'newsDetails',
      component: NewsDetails
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/joinUs',
      name: 'joinUs',
      component: JoinUs
    },
    {
      path: '/elements',
      name: 'elements',
      component: Elements
    },
    {
      path: '/search',

      name: 'search',
      component: Search
    },
    {
      path: '/refresh',
      component: resolve => require(['@/pages/refresh'], resolve),
      meta: {
        title: '用于同路由刷新'
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.name != 'home' && to.name != 'products' && to.name != 'productDetails' && to.name != 'fanMoney' && to.name != 'activity' && to.name != 'retrospect' && to.name != 'productionPart' && to.name != 'searchPost' && to.name != 'carSystem' && to.name != 'fmMoneyGoods') {
      window.scrollTo(0, 0);
    }
  }
});





// WEBPACK FOOTER //
// ./src/router/index.js